import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./mainten.scss";
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import AddIcon from '@mui/icons-material/Add';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";

import EditIcon from "@mui/icons-material/Edit";
import { deleteMaintenance, fetchMaintenance, updateStatus } from "../../store/slices/thunk";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/deleteModal";
import Loader from "../../components/loader";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const MaintenanceList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllMaintenance, setAllMaintenance] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllMaintenance);
  const handleChange = (e: any) => {
    setSelectedVehicle(e.target.value);
  };

  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(fetchMaintenance(page, ITEMS_PER_PAGE, search));
        if (response && response?.data?.data?.length > 0 && response?.isSuccess) {
          setAllMaintenance(response?.data?.data);
          setTotalCount(response?.data?.totalCount);
        } else {
          setAllMaintenance([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.log(getAllMaintenance);
        setAllMaintenance([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false); // Stop loader
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    }
  }
    , [search, page, dispatch]);

  const gotoEdit = (id: string) => {
    navigate(`/edit-maintenance/${id}`);
  };
  const handleDelete = async (id: string) => {
    const response = await dispatch(deleteMaintenance(id))
    if (response.isSuccess) {
      const newMaintenance = getAllMaintenance.filter((item: any) => item._id !== id);
      setAllMaintenance(newMaintenance);
    }
  }


  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await handleDelete(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };
  const navigateToMaintenanceAdd = () => {
    navigate("/add-maintenance");
  };
  const handleUpdateStatus = async (id: string, status: string) => {
    const response = await dispatch(updateStatus(id, status));
    if (response.isSuccess) {
      console.log("Status updated successfully");
      setAllMaintenance((prev: any) => prev.map((item: any) => {
        if (item._id === id) {
          return { ...item, maintenanceStatus: status };
        } else {
          return item;
        }
      }));
    } else {
      console.log("Failed to update status");
    }
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="maintenance-list" style={{ flexShrink: 0 }}>
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              Maintenance Management
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              Track and manage vehicle maintenance schedules
            </p>
          </div>
        <p>
          {" "}
                   <button className="py-2 px-2" onClick={navigateToMaintenanceAdd} style={{background:" #3b82f6", color:"#fff", borderRadius:"10px", border:"none", height:"auto", width:"auto"}}> <AddIcon />Add New Maintenaince</button>
        </p>
      </div>
      <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
    <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                  <div className="search-box align-items-baseline justify-content-start" style={{ flexShrink: 0 }}>
                    <div className="search-wrapper">
                      <IoSearchOutline className="search-icon" />
                      <input
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search Maintenance Here"
                      />
                    </div>
          </div>


        <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
         
          <Table className="m-table">
            <TableHead className="th">
           <TableRow className="table-h-row">
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    S.No
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Vehicle
    <FilterPopover column="vehicle.vehicleName" filterType="text" currentValue={filters["vehicle.vehicleName"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Service Info
    <FilterPopover column="serviceDetails" filterType="text" currentValue={filters.serviceDetails || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Vendor
    <FilterPopover column="vendorName" filterType="text" currentValue={filters.vendorName || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Cost
    <FilterPopover column="totalCost" filterType="text" currentValue={filters.totalCost || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Status
    <FilterPopover column="maintenanceStatus" filterType="text" currentValue={filters.maintenanceStatus || ""} onFilterChange={setFilter} onClear={clearFilter} />
  </TableCell>
  <TableCell
    className="table-cell"
    style={{ background: "#f9fafb", color: "#374151", fontWeight: 500, fontSize: "18px" }}
  >
    Action
  </TableCell>
</TableRow>


            </TableHead>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (

              <TableBody className="tb">
                {filteredData.map((item: any, index) => (
                  <TableRow key={index} className="t-row">
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>{index + 1}</TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.vehicle.vehicleName || "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.serviceDetails || "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.vendorName || "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      {item.totalCost || "--"}
                    </TableCell>
                    <TableCell className="table-cell" style={{fontWeight:"200",fontSize:"0.875rem"}}>
                      <select
                        value={item.maintenanceStatus}
                        style={{ borderRadius: "30px", padding: "10px" }}
                        onChange={(e: any) => handleUpdateStatus(item._id, e.target.value)}
                      >
                        <option value="">-- Select --</option>
                        <option value="completed">Completed</option>
                        <option value="planned">Planned</option>
                        <option value="inProgress">InProgress</option>
                      </select>
                    </TableCell>  
                    <TableCell className="table-cell">
                      <IconButton >
                        <MdDelete onClick={() => handleDeleteClick(item._id)} style={{ color: "red" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                <ConfirmDialog
                  open={openDialog}
                  onClose={() => setOpenDialog(false)}
                  onConfirm={confirmDelete}
                />
                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Maintenance Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}

          </Table>
        </TableContainer>
    </div>
        <nav style={{ flexShrink: 0 }}>
          <ul className="pagination  mt-3 justify-content-center">
            <li
              className={`page-item ${page === 1 && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.max(p - 1, 1))
                }
              >
                Previous
              </button>
            </li>

            {Array.from(
              { length: Math.min(5, pageCount) },
              (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              )
            )}

            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => setPage(pageCount)}
                  >
                    {pageCount}
                  </button>
                </li>
              </>
            )}

            <li
              className={`page-item ${page === pageCount && "disabled"
                }`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setPage((p) => Math.min(p + 1, pageCount))
                }
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </Paper>
    </div>
  );
};

export default MaintenanceList;

